import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@qga/roo-ui/components';
import useCampaignPriceMessage from './useCampaignPriceMessage';

const CampaignPriceMessage = ({ currency, fallback, color }) => {
  const { showCampaignPriceMessage, campaignPriceMessage } = useCampaignPriceMessage({ currency, fallback });
  if (!showCampaignPriceMessage && !fallback) return null;

  return (
    <Text color={color ?? 'brand.primary'} fontSize="sm" textAlign="left" data-testid="campaign-price-message">
      {campaignPriceMessage}
    </Text>
  );
};

CampaignPriceMessage.propTypes = {
  color: PropTypes.string,
  currency: PropTypes.string.isRequired,
  fallback: PropTypes.bool,
  luxuryInclusions: PropTypes.bool,
  offerType: PropTypes.string,
};

CampaignPriceMessage.defaultProps = {
  fallback: false,
  luxuryInclusions: false,
};

export default CampaignPriceMessage;
